import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { ServiceCategoryDto, CreateServiceCategoryDto, UpdateServiceCategoryDto } from 'interfaces/service_category';
import { ReorderItem } from 'interfaces/reorder_item';

interface ServiceCategoriesService {
  getServiceCategories(): Promise<ServiceCategoryDto[]>;
  getServiceCategory(id: number): Promise<ServiceCategoryDto>;
  createServiceCategory(postData: CreateServiceCategoryDto): Promise<AxiosResponse<any>>;
  editServiceCategory(id: number, postData: UpdateServiceCategoryDto): Promise<AxiosResponse<any>>;
  deleteServiceCategory(id: number): Promise<AxiosResponse<any>>;
  reorderServiceCategories(items: ReorderItem[]): Promise<AxiosResponse<any>>;
}

const endpoints = {
  getServiceCategories: '/service-categories',
  getServiceCategory: (id: number) => `/service-categories/${id}`,
  createServiceCategory: '/service-categories',
  editServiceCategory: (id: number) => `/service-categories/${id}`,
  deleteServiceCategory: (id: number) => `/service-categories/${id}`,
  reorderServiceCategories: '/service-categories',
};

export const serviceCategoriesService: ServiceCategoriesService = {
  getServiceCategories: async (): Promise<ServiceCategoryDto[]> => {
    const response: AxiosResponse<ApiResponseDto<ServiceCategoryDto[]>> = await apiClient.get(endpoints.getServiceCategories);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  getServiceCategory: async (id: number): Promise<ServiceCategoryDto> => {
    const response: AxiosResponse<ApiResponseDto<ServiceCategoryDto>> = await apiClient.get(endpoints.getServiceCategory(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  createServiceCategory: async (postData: CreateServiceCategoryDto): Promise<AxiosResponse<any>> => {
    return apiClient.post(endpoints.createServiceCategory, postData);
  },
  editServiceCategory: async (id: number, postData: UpdateServiceCategoryDto): Promise<AxiosResponse<any>> => {
    return apiClient.put(endpoints.editServiceCategory(id), postData);
  },
  deleteServiceCategory: async (id: number): Promise<AxiosResponse<any>> => {
    return apiClient.delete(endpoints.deleteServiceCategory(id));
  },
  reorderServiceCategories: async (items: ReorderItem[]): Promise<AxiosResponse<any>> => {
    return apiClient.patch(endpoints.reorderServiceCategories, items);
  },
};
